import sliderHome from "./sliderHome";

let menuMain = {
    init() {
        $('.main-menu nav > ul').addClass('level1');

        $('.main-menu .level1 > .menu-item--expanded').each(function () {
            $('ul', this).addClass('sub-menu');
            $(this).addClass('nolink');
        })

        $('.main-menu .sub-menu .sub-menu').addClass('sub-menu2');


        $('.main-menu .level1 > .menu-item.nolink > a').click(function () {
            event.preventDefault();
        })

        $('.main-menu .nolink > a, .main-menu .nolink > span').click(function () {
            if ($(this).parent().hasClass('active')) {
                $(this).parent().removeClass('active');
                $(this).removeClass('active');
                $('.main-menu .sub-menu').slideUp(300);

            } else {
                $('.main-menu .nolink').removeClass('active');
                $(this).parent().addClass('active');
                $('.main-menu .nolink > a').removeClass('active');
                $(this).addClass('active');
                $('.main-menu .sub-menu').slideUp(300);
                $(this).parent().find('.sub-menu').slideDown(300);
            }
        })


        $('.header-right .menu, .header-right-pro .menu').click(function () {
            $('.main-menu').toggleClass('open');
            $('.main-menu nav').toggleClass('open');
            $(this).toggleClass('active');
            $('body').toggleClass('noscroll');
            $('.main-menu .sub-menu').slideUp(300);
            $('.main-menu .nolink a').removeClass('active');
            $('.sliderhome').toggleClass('menu-open');
        })


        $(document).click(function (event) {
            if ($(event.target).hasClass('menu-overlay')) {
                $('.main-menu').toggleClass('open');
                $('.main-menu nav').toggleClass('open');
                $('.header-right .menu, .header-right-pro .menu').toggleClass('active');
                $('body').removeClass('noscroll');
                $('.main-menu .sub-menu').slideUp(300);
                $('.main-menu .nolink a').removeClass('active');
                $('.sliderhome').removeClass('menu-open');

            }
            if ($(window).width() < 801) {
                if ($('.main-menu nav p.username').length < 1) {
                    $('.user-block p.username').clone().prependTo(".main-menu nav");
                }
            } else {
                $('.main-menu nav p.username').remove();
            }
        });

    }
}

export default menuMain;
